import { UseQueryResult, useQuery } from 'react-query';
import ShieldGPSAxiosClient from '../lib/ShieldGPSAxiosClient';
import {
  DeviceDataPage,
  DevicePacketRecord,
  DevicePositionRecord,
} from '../models/Device';

export const DEVICE_DATA_PAGE_SIZE = 20;

type DeviceDataKind = 'packets' | 'positions';

export const getDeviceDataPage = async <T,>(
  imei: string,
  kind: DeviceDataKind,
  cursor?: string,
): Promise<DeviceDataPage<T>> => {
  const response = await ShieldGPSAxiosClient.get<DeviceDataPage<T>>(
    `/admin/user-search/devices/${imei}/${kind}`,
    {
      params: {
        limit: DEVICE_DATA_PAGE_SIZE,
        ...(cursor ? { cursor } : {}),
      },
    },
  );

  return response.data;
};

const useDeviceDataPage = <T,>(
  imei: string,
  kind: DeviceDataKind,
  cursor?: string,
): UseQueryResult<DeviceDataPage<T>, unknown> => {
  return useQuery(
    ['device-data', imei, kind, cursor ?? null],
    () => getDeviceDataPage<T>(imei, kind, cursor),
    {
      enabled: !!imei,
      keepPreviousData: true,
      retry: false,
    },
  );
};

export const useDevicePackets = (imei: string, cursor?: string) =>
  useDeviceDataPage<DevicePacketRecord>(imei, 'packets', cursor);

export const useDevicePositions = (imei: string, cursor?: string) =>
  useDeviceDataPage<DevicePositionRecord>(imei, 'positions', cursor);
